<template>
    <div></div>
</template>

<script setup lang="ts">
import {onBeforeMount} from '#imports';
import {getCookie, removeCookie, setCookie} from "~~/package/utils/CookieUtil";
import {useUserService} from "~/composables/service/useUserService";
import {useUserStore} from "~/store/user/userStore";
import {useRouter} from "#app";
import type {UserV2Model} from "~~/package/mapper/user/model/UserV2Model";
import { CookieKeyType } from "~~/package/mapper/common/model/CookieKeyType";
import { SignType, SignUIType } from "~/components/Sign/enum/SignType";

const {$i18n} = useNuxtApp();
const userStore = useUserStore();
const router = useRouter();

onBeforeMount(() => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  const error = urlSearchParams.get("error") as string;

  if(token && token.length > 0){
    // SEC-1 (TSK-10568): HttpOnly AccessToken cookie set by OAuth2SuccessHandlerService before redirect.
    // ?token= URL param retained for legacy clients (SEC-2 separate ticket).
    setCookie(CookieKeyType.OPEN_CREDIT_BANNER, true);
    settingUser().then((user: UserV2Model) => {
      if(!isEmptyString(user.uuid)){
        if (user.location) {
          if(getCookie(CookieKeyType.REDIRECT_URL)){
            userStore.moveToRedirectUrl();
            removeCookie(CookieKeyType.REDIRECT_URL);
          }
          else {
            router.push({ path: "/dashboard" });
          }
        }
        else router.replace({ path: "/register/info" });
      }
    })
  }
  else if(token === null){
    handleLoginFail(error);
  }
});

const settingUser = async (): Promise<UserV2Model> => {
  await useUserService().setUser();
  await useUserService().setUserLocale($i18n.locale.value)
  return userStore.userV2
}

const handleLoginFail = (error:string) => {
  // SEC-1 (TSK-10568): clear any cookie that may have been set; best-effort fire-and-forget
  // since this is the failure path and we redirect immediately.
  useUserService().userSignOut().catch(() => { /* ignore */ });
  removeCookie(CookieKeyType.ACCESS_TOKEN);
  removeCookie(CookieKeyType.OPEN_CREDIT_BANNER);
  setTimeout(() => {
    router.replace({
      path: "/sign",
      query: {
        uiType: SignUIType.LOGIN,
        type: SignType.CANDIDATE,
        code: error
      }
    });
  })
}

</script>
